__turbopack_context__.v({
  "root": "Spacer-module__ui-RyG__root",
});
